import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home/Index.vue'),
      meta: { title: '首页' }
    },
    {
      path: '/services',
      name: 'Services',
      redirect: '/services/main',
      meta: { title: '服务' }
    },
    {
      path: '/services/main',
      name: 'ServicesMain',
      component: () => import('@/views/Home/Services.vue'),
      meta: { title: '服务' }
    },
    {
      path: '/services/rental',
      name: 'Rental',
      component: () => import('@/views/Services/Rental.vue'),
      meta: { title: 'GPU租赁' }
    },
    {
      path: '/services/consultation',
      name: 'Consultation',
      component: () => import('@/views/Services/Consultation.vue'),
      meta: { title: '咨询服务' }
    },
    {
      path: '/models',
      name: 'Models',
      component: () => import('@/views/Models/Index.vue'),
      meta: { title: '模型' }
    },
    {
      path: '/models/:id',
      name: 'ModelDetail',
      component: () => import('@/views/Models/Detail.vue'),
      meta: { title: '模型详情', requiresAuth: true }
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: () => import('@/views/Pricing/Index.vue'),
      meta: { title: '价格' }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/Contact/Index.vue'),
      meta: { title: '联系我们' }
    },
    {
      path: '/consultation',
      name: 'ConsultationPage',
      component: () => import('@/views/Consultation/Index.vue'),
      meta: { title: '在线咨询' }
    },
    {
      path: '/quote',
      name: 'Quote',
      component: () => import('@/views/Quote/Index.vue'),
      meta: { title: '获取报价' }
    },
    {
      path: '/docs',
      name: 'Docs',
      component: () => import('@/views/Docs/Index.vue'),
      meta: { title: '文档' },
      children: [
        {
          path: '',
          redirect: '/docs/guide'
        },
        {
          path: 'guide',
          name: 'DocsGuide',
          component: () => import('@/views/Docs/Guide.vue'),
          meta: { title: '用户指南' }
        },
        {
          path: 'examples',
          name: 'DocsExamples',
          component: () => import('@/views/Docs/Examples.vue'),
          meta: { title: '场景示例' }
        },
        {
          path: 'api',
          name: 'DocsApi',
          component: () => import('@/views/Docs/Api.vue'),
          meta: { title: 'API手册' }
        },
        {
          path: 'changelog',
          name: 'DocsChangelog',
          component: () => import('@/views/Docs/Changelog.vue'),
          meta: { title: '更新公告' }
        },
        {
          path: 'terms',
          name: 'DocsTerms',
          component: () => import('@/views/Docs/Terms.vue'),
          meta: { title: '条款与协议' }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login/Index.vue'),
      meta: { title: '登录', guestOnly: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/Login/Register.vue'),
      meta: { title: '注册', guestOnly: true }
    },
    {
      path: '/console',
      name: 'Console',
      component: () => import('@/views/Console/Layout.vue'),
      meta: { title: '控制台', requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/console/models'
        },
        {
          path: 'models',
          name: 'ConsoleModels',
          component: () => import('@/views/Console/Models.vue'),
          meta: { title: '我的模型' }
        },
        {
          path: 'playground',
          name: 'ConsolePlayground',
          component: () => import('@/views/Console/Playground.vue'),
          meta: { title: '体验中心' }
        },
        {
          path: 'account',
          name: 'ConsoleAccount',
          component: () => import('@/views/Console/Account.vue'),
          meta: { title: '账户管理' }
        },
        {
          path: 'activities',
          name: 'ConsoleActivities',
          component: () => import('@/views/Console/Activities.vue'),
          meta: { title: '活动中心' }
        },
        {
          path: 'finetune',
          name: 'ConsoleFinetune',
          component: () => import('@/views/Console/Finetune.vue'),
          meta: { title: '模型微调' }
        }
      ]
    }
  ],
  scrollBehavior() {
    return { top: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 黔前智算` : '黔前智算'
  
  // 需要登录的页面
  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  
  // 仅游客可访问的页面（登录、注册）
  if (to.meta.guestOnly && userStore.isLoggedIn) {
    next('/console')
    return
  }
  
  next()
})

export default router